const ROUNDING_ERROR_FIX = 1;

/**
 * Returns the potential width of an element if none of the containing text nodes were truncated.
 *
 * @param el The element to calculate the potential width of.
 * @returns The potential width of the element.
 */
const getPotentialElementWidth = (el: HTMLElement): number => {
  // the root itself could be the one that's overflowing so we start with that
  let width = el.scrollWidth;

  const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);

  while (walker.nextNode()) {
    const parent = walker.currentNode.parentElement;

    if (parent && parent.scrollWidth > parent.clientWidth) {
      // we need to subscract the client width it is already part of the initial maxWidth
      width = width - parent.clientWidth + parent.scrollWidth;
    }
  }

  // scrollWidth will only return integer and not subpixel values,
  // therefore we allways add 1 to the width so that the potential width
  // is slightly wider than the real width to avoid any truncations
  return width + ROUNDING_ERROR_FIX;
};

export default getPotentialElementWidth;
